import { render } from "./error_page.vue?vue&type=template&id=a366db78&scoped=true"
import script from "./error_page.vue?vue&type=script&lang=js"
export * from "./error_page.vue?vue&type=script&lang=js"

import "./error_page.vue?vue&type=style&index=0&id=a366db78&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/WaterQualityFrontEnd_Vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a366db78"]])

export default __exports__